import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors, spacingSizesMap } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $horizontalDivider': {
      backgroundColor: hexToRGBA(TextColors.light, TextOpacities.light4),
    },

    '& $rtc': {
      '& h5': {
        color: SecondaryColors.main,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $horizontalDivider': {
      backgroundColor: hexToRGBA(TextColors.dark, TextOpacities.dark4),
    },

    '& $rtc': {
      '& h5': {
        color: SecondaryColors.dark,
      },
    },
  },
};

const bottomSpacing = {
  '&.bottom-small': {
    '& $horizontalDivider': {
      bottom: 1 - spacingSizesMap.small,
    },
  },

  '&.bottom-medium': {
    '& $horizontalDivider': {
      bottom: 1 - spacingSizesMap.medium,
    },
  },

  '&.bottom-large': {
    '& $horizontalDivider': {
      bottom: 1 - spacingSizesMap.large,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      ...bottomSpacing,
      '&.aos-true .react-reveal': {
        animationDuration: '0.01ms !important',
        animationIterationCount: '1 !important',
        transitionDuration: '0.01ms !important',
        scrollBehavior: 'auto !important',
      },
    },
    content: {
      '& > * > * + *': {
        marginTop: muiTheme.spacing(3),
      },
      '& > * > .capture-clicks': {
        width: 'inherit',
      },
      /* Button Links as standalone top-level content are always centered */
      '& > [class*="GenDetailContent-root"] > .MuiButton-root': {
        margin: '0 auto',
      },
    },
    link: {
      display: 'inline-block',
      margin: 0,

      [muiTheme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    horizontalDivider: {
      height: 1,
      width: '100%',
      position: 'relative',
    },
    multiLink: {
      margin: muiTheme.spacing(-1.5),
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',

      '& > .buttonWrapper': {
        padding: muiTheme.spacing(1.5),

        '& > *': {
          width: '100%',
        },

        [muiTheme.breakpoints.down('xs')]: {
          width: '100%',
        },
      },
    },
    columnContent: {
      '& .columns': {
        '& .column': {
          '& > * > * + *': {
            marginTop: muiTheme.spacing(3),
          },
        },
      },
    },
    columnCenterAlign: {
      '& .columns': {
        alignItems: 'center',
        alignContent: 'center',
      },
    },
    columnBottomAlign: {
      '& .columns': {
        alignItems: 'flex-end',
        alignContent: 'flex-end',
      },
    },
    rtc: {},
  }),
  { name: 'GenRichContent' },
);

export default useStyles;
